module.exports = __webpack_public_path__ + "static/WEDDING E&M-270-14f857dd4b5ce10e1aa469a21f7406a9.jpg";